<template lang="">
  <input-modal
    v-model="conteudo"
    :label="label"
    :placeholder="placeholder"
    :dense="dense"
    :regras="regras"
    :disabled="disabled"
    :multiplos="multiplos"
    :retornar-objeto="retornarObjeto"
    :obrigatorio="obrigatorio"
    @abrir-modal="abrirModal"
    @input="emitirInput"
  >
    <template #depois-label>
      <slot name="depois-label" />
    </template>
    <template #modal>
      <modal-padrao
        ref="modal-input"
        :max-width="EhTelaPequena ? '90%' : '60%'"
        :titulo="titulo || $t('componentes.input_participantes.titulo_modal')"
        :titulo-ok="$t('geral.botoes.confirmar')"
        @ok="aplicarSelecionados"
      >
        <modal
          ref="modal"
          :key="componentKey"
          v-model="selecionados"
          :multiplos="multiplos"
          :participante-conta="participanteConta"
          :flag-fornecedor="flagFornecedor"
          @fechar-modal-click-linha="aplicarSelecionados"
          @opened="focusInput(modal)"
        />
      </modal-padrao>
    </template>
  </input-modal>
</template>
<script>
import { InputMixin } from '../../InputMixin';
import { DropdownModelDoisParametros } from '@common/models/geral/DropdownModelDoisParametros';
import Modal from './modal.vue';
import _ from 'lodash';
export default {
  name: 'InputParticipantes',
  components: {
    Modal,
  },
  mixins: [InputMixin],
  props: {
    multiplos: { type: Boolean, default: true },
    retornarObjeto: { type: Boolean, default: true },
    participanteConta: { type: Boolean, default: false },
    flagFornecedor: {
      type: [Number, String],
      default: null,
    },
    titulo: {
      type: String,
      default: null,
    },
  },
  data: function () {
    return {
      componentKey: 0,
      conteudo: [],
      selecionados: [],
    };
  },
  computed: {
    regras: function () {
      let regras = this.regrasPersonalizadas;
      if (this.obrigatorio) regras.push(this.validacaoObrigatorio);
      return regras;
    },
    EhTelaPequena() {
      return ['sm', 'xs'].includes(this.$vuetify.breakpoint.name);
    },
  },
  watch: {
    value: {
      handler(value) {
        this.conteudo = value;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    emitirInput: function () {
      this.$emit('input', this.conteudo);
    },
    emitirOk: function () {
      this.$emit('ok', this.conteudo);
    },
    textoOpcao: function (opcao) {
      if (!opcao) return '';
      return opcao.text || opcao;
    },
    removerOpcao: function (indice) {
      this.conteudo.splice(indice, 1);
    },
    abrirModal: function () {
      this.$refs['modal-input'].abrirModal();
      this.componentKey++;
      setTimeout(() => {
        this.$refs.modal.listar();
      }, 500);
      if (!this.conteudo) return false;

      let conteudoClonado = _.cloneDeep(this.conteudo);
      if (!this.multiplos) conteudoClonado = [conteudoClonado];

      this.selecionados = conteudoClonado.map((el) => {
        return {
          id: el.value,
          nome: el.text,
        };
      });
    },
    aplicarSelecionados: function () {
      this.$refs['modal-input'].fecharModal();
      let selecionados = new DropdownModelDoisParametros(
        this.selecionados,
        'apelido',
        'flagParticipanteConta'
      );

      if (!this.multiplos) {
        selecionados = null;
        if (this.selecionados.length > 0) {
          selecionados = new DropdownModelDoisParametros(
            this.selecionados,
            'apelido',
            'flagParticipanteConta'
          )[0];
          if(selecionados.value == this.selecionados[0].id){
            selecionados.text = this.selecionados[0].nome
          }
        }
      }
      this.conteudo = selecionados;
    },
    fechaModal() {
      this.$refs['modal-input'].fecharModal();
      this.selecionados = [];
    },
  },
};
</script>
